import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: number[] = [];

const templatePlaceholdersIndexesSlice = createSlice({
  name: 'templatePlaceholdersIndexes',
  initialState,
  reducers: {
    addPlaceholderIndex: (state, action: PayloadAction<number>) => {
      if (!state.includes(action.payload)) {
        state.push(action.payload);
      }
    },
    removePlaceholderIndex: (state, action: PayloadAction<number>) => {
      return state.filter((id) => id !== action.payload);
    },
    clearPlaceholdersIndexes: () => initialState,
  },
});

export const { addPlaceholderIndex, removePlaceholderIndex, clearPlaceholdersIndexes } =
  templatePlaceholdersIndexesSlice.actions;

export default templatePlaceholdersIndexesSlice.reducer;

export const selectTemplatePlaceholdersIndexes = (state: {
  templatePlaceholdersIndexes: number[];
}) => state.templatePlaceholdersIndexes;
